import { useState } from "react";
import {
	List,
	ListItem,
	ListItemText,
	Typography,
	ListItemIcon,
	Collapse,
} from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import InvestmentTypeGroup from "./InvestmentTypeGroup";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

export default function InvestmentBudgetGroup({ investment, period, color }) {
	const userCurrency = localStorage.getItem("userCurrency");
	const theme = useTheme();
	const { t } = useTranslation();

	const [isExpanded, setIsExpanded] = useState(true);

	const totalUsed = investment.reduce(
		(sum, g) => sum + g.totalTransactionsSum,
		0,
	);
	const totalBudget = investment.reduce((sum, g) => sum + g.totalBudget, 0);

	const balanceStyles = {
		color:
			totalUsed >= totalBudget
				? theme.palette.values.positive
				: theme.palette.values.negative,
	};

	return (
		<List
			sx={{
				flexGrow: 1,
				backgroundColor: theme.palette.background.paper,
				borderRadius: "10px",
			}}
		>
			<ListItem sx={{ pt: 0, pb: 0 }}>
				<ListItemText
					primary={
						<Typography
							variant="h6"
							sx={{
								display: "flex",
								alignItems: "center",
								gap: 1,
								fontWeight: "bold",
								color,
							}}
						>
							<TrendingUpIcon />
							{t("investments")}
						</Typography>
					}
				/>
				<Typography
					variant="h6"
					sx={{
						marginBottom: 0,
						fontWeight: "bold",
						textAlign: "right",
						whiteSpace: "nowrap",
						...balanceStyles,
					}}
				>
					{totalUsed.toFixed(2).toLocaleString()} {userCurrency}
				</Typography>
				<Typography
					variant="h6"
					sx={{
						marginBottom: 0,
						mx: 1,
						fontWeight: "bold",
						textAlign: "right",
						whiteSpace: "nowrap",
					}}
				>
					{"/"}
				</Typography>
				<Typography
					variant="h6"
					sx={{
						marginBottom: 0,
						fontWeight: "bold",
						textAlign: "right",
						whiteSpace: "nowrap",
					}}
				>
					{" "}
					{Math.abs(totalBudget).toFixed(2).toLocaleString()}{" "}
					{userCurrency}
				</Typography>
				{investment.length > 0 && (
					<ListItemIcon sx={{ minWidth: "auto", ml: 1 }}>
						{isExpanded ? (
							<ExpandLess
								sx={{ cursor: "pointer" }}
								onClick={() => setIsExpanded(!isExpanded)}
							/>
						) : (
							<ExpandMore
								sx={{ cursor: "pointer" }}
								onClick={() => setIsExpanded(!isExpanded)}
							/>
						)}
					</ListItemIcon>
				)}
			</ListItem>
			<Collapse in={isExpanded}>
				{investment.map((group) => (
					<InvestmentTypeGroup
						key={group.type}
						group={group}
						period={period}
					/>
				))}
			</Collapse>
		</List>
	);
}
